export default "__VITE_ASSET__lPLPbV3S__"